// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2ddqA","info":"PatientInfo_info__1DdDS"};